// JsFromRoutes CacheKey 4da06037129aa836afca8df7b706a265
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  create: definePathHelper('post', '(/:admin)/custom_attributes'),
}
